import type { InputT } from "@patient-watch/types";
import React from "react";
import { useFieldArray } from "react-hook-form";
import type { Control } from "react-hook-form";
import InputSwitchSimple from "./InputSwitchSimple";
// Define the form data structure
interface FormData {
    [key: string]: {
        values: Array<{
            input_id: string;
            value: string;
        }>;
    };
}

interface RepeatableGroupEntryProps {
    repeatableGroupInputId: string;
    groupIndex: number;
    control: Control<FormData>;
    inputs: InputT[];
}

export default ({ repeatableGroupInputId, groupIndex, control, inputs = [] }: RepeatableGroupEntryProps) => {
    useFieldArray({
        control,
        name: `${repeatableGroupInputId}.${groupIndex}.values`,
    });

    return (
        <div className="space-y-4 mt-2">
            {inputs.map((input, k) => {
                return (
                    <div key={input.input_id} className="flex items-center gap-2">
                        <InputSwitchSimple
                            name={`${repeatableGroupInputId}.${groupIndex}.values.${k}.${input.input_id}`}
                            label={input?.input_label || `Input ${k + 1}`}
                            inputKey={input.input_key || ""}
                        />
                    </div>
                );
            })}
        </div>
    );
};
